<template>
  <div class="tpp-page">
    <zhuomuniao-ops-nav active-path="/pages/tpp/zhuomuniao/city-maps" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div>
          <h2 class="tpp-panel__title">城市映射</h2>
          <p class="tpp-muted">小区对应对方线下城市编码。下单必须有映射；禁止用门牌逆地理猜 cityId。</p>
        </div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openEditor()">新增映射</el-button>
      </div>
      <div class="tpp-filter">
        <el-select v-model="filters.communityId" placeholder="全部小区" clearable filterable style="width:200px">
          <el-option v-for="item in communityOptions" :key="item.communityId" :label="item.name" :value="item.communityId" />
        </el-select>
        <el-input v-model.trim="filters.cityId" placeholder="城市 ID" clearable style="width:160px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </div>
    </section>
    <section class="tpp-panel">
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column label="小区" min-width="160">
          <template slot-scope="scope">{{ scope.row.communityName || scope.row.communityId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="cityId" label="城市 ID" width="120" />
        <el-table-column prop="regionName" label="行政区" min-width="140" />
        <el-table-column label="可服务" width="90" align="center">
          <template slot-scope="scope"><el-tag :type="scope.row.serviceable === 'Y' ? 'success' : 'info'" size="small">{{ scope.row.serviceable === 'Y' ? '是' : '否' }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openEditor(scope.row)">编辑</el-button>
            <el-button type="text" class="tpp-danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="tpp-pagination" :current-page.sync="page.current" :page-size="page.size" :total="page.total"
        layout="total, prev, pager, next" @current-change="load" />
    </section>
    <el-dialog :title="form.mapId ? '编辑城市映射' : '新增城市映射'" :visible.sync="editorVisible" width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="小区" prop="communityId">
          <el-select v-model="form.communityId" filterable style="width:100%" :disabled="!!form.mapId">
            <el-option v-for="item in communityOptions" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item label="城市 ID" prop="cityId"><el-input v-model.trim="form.cityId" maxlength="32" placeholder="对方线下编码，勿自造" /></el-form-item>
        <el-form-item label="行政区"><el-input v-model.trim="form.regionName" maxlength="64" /></el-form-item>
        <el-form-item label="可服务">
          <el-radio-group v-model="form.serviceable"><el-radio label="Y">是</el-radio><el-radio label="N">否</el-radio></el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="editorVisible=false">取消</el-button><el-button type="primary" :loading="saving" @click="submit">保存</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import ZhuomuniaoOpsNav from './zhuomuniaoNav.vue'
import { zhuomuniaoOpsMixin } from './zhuomuniaoOpsMixin'
import { listCityMaps, saveCityMap, updateCityMap, deleteCityMap } from '@/api/life/homeServiceApi'
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'
import { zmnTotal } from '@/api/tpp/zhuomuniaoOpsApi'
import '../tpp.scss'
function emptyForm() { return { mapId: '', communityId: '', cityId: '', regionName: '', serviceable: 'Y' } }
export default {
  name: 'ZhuomuniaoCityMaps',
  components: { ZhuomuniaoOpsNav },
  mixins: [zhuomuniaoOpsMixin],
  data() {
    return {
      loading: false, saving: false, editorVisible: false, rows: [], communityOptions: [],
      filters: { communityId: '', cityId: '' }, page: { current: 1, size: 10, total: 0 }, form: emptyForm(),
      rules: {
        communityId: [{ required: true, message: '请选择小区', trigger: 'change' }],
        cityId: [{ required: true, message: '请输入城市 ID', trigger: 'blur' }]
      }
    }
  },
  async created() {
    if (await this.ensureZhuomuniaoPlatform()) {
      this.loadCommunities()
      this.load()
    }
  },
  methods: {
    search() { this.page.current = 1; this.load() },
    async loadCommunities() {
      try { const res = await listAdminCommunitys({ page: 1, row: 500 }); this.communityOptions = res.data || [] }
      catch (e) { this.communityOptions = [] }
    },
    async load() {
      this.loading = true
      try {
        const res = await listCityMaps({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = zmnTotal(res)
      } catch (e) { this.$message.error(e.message || '城市映射加载失败') }
      finally { this.loading = false }
    },
    openEditor(row) {
      this.form = row ? { ...row } : emptyForm()
      this.editorVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          if (this.form.mapId) await updateCityMap(this.form)
          else await saveCityMap(this.form)
          this.$message.success('城市映射已保存')
          this.editorVisible = false
          this.load()
        } catch (e) { this.$message.error(e.message || '保存失败') }
        finally { this.saving = false }
      })
    },
    async remove(row) {
      try {
        await this.$confirm('删除映射后该小区新单无法同步到啄木鸟。若仍有上架发布，请先下架。', '删除映射', { type: 'warning' })
        await deleteCityMap({ mapId: row.mapId })
        this.$message.success('已删除'); this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message || '删除失败') }
    }
  }
}
</script>
